import { z } from "zod";

/**
 * URL search params for the member's benefits page.
 *
 * KEYS ONLY, never values (FE-SEC7). A period id is opaque and safe to
 * bookmark; the amounts a plan is built from travel in POST bodies.
 */
export const benefitsRouteSearchSchema = z
  .object({
    /// Which payroll period the plan and claims are about.
    period: z.string().optional(),
  })
  .strict();

export type BenefitsRouteSearch = z.infer<typeof benefitsRouteSearchSchema>;
